import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar',
  imports: [],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}
